import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfWhatInBox, { EfWhatInBoxItemProps } from '@elem/ui/ef-what-in-box';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from './../../../ProductProvider';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = '' } = useRouter();
    const { pageStatus } = useProductStore();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'uk', 'ph'].includes(locale ?? '');
    const IS_EU = ['eu', 'de', 'fr', 'it', 'es', 'uk'].includes(locale);
    const IS_NA = ['us', 'ca'].includes(locale);
    let imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1724664073834/dd2.png';

    if (['uk'].includes(locale)) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1732529485969/uk.png';
    } else if (IS_EU_SITES) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1731924318317/product.png';
    } else if (['au'].includes(locale)) {
        imgUrl = 'https://websiteoss.ecoflow.com/upload/image/1736932656168/EcoFlow%20DELTA%203%20Plus.png';
    }

    const list: EfWhatInBoxItemProps[] = [
        {
            title: t('N_text1'),
            pc: imgUrl,
        },
        {
            title: t('N_text2'),
            pc: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1730081358098/AC_cable_eu.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1725500461530/AC_cable_na.png',
        },
        {
            title: t('N_text3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816399/a2.png',
        },
        {
            title: t('N_text4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816161/a3.png',
        },
        {
            title: t('N_text5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816618/a4.png',
        },
    ];

    const list_eu_na: EfWhatInBoxItemProps[] = [
        {
            title: t('N_text1'),
            pc: imgUrl,
        },
        {
            title: t('N_text2'),
            pc: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1730081358098/AC_cable_eu.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1725500461530/AC_cable_na.png',
        },
        {
            title: t('N_text5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724663816618/a4.png',
        },
    ];

    if (IS_EU_SITES && pageStatus !== 'statusB') {
        return null;
    }

    const list_PH = [
        {
            title: t('N_text1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751015162691/sl_d3s%402x.png',
        },
        {
            title: t('N_text2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751015162151/EcoFlow%20AC%20Charging%20Cable.png',
        },
        {
            title: t('N_text3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751015162402/EcoFlow%20Car%20Charging%20Cable.png',
        },
        {
            title: t('N_text4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751015161890/DC5521%20to%20DC5525%20Cable.png',
        },
        {
            title: t('N_text5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751015161603/%E8%AF%B4%E6%98%8E%E4%B9%A6%E5%92%8C%E4%BF%9D%E4%BF%AE%E5%8D%A1.png',
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfTitle>{t('N_title')}</EfTitle>
            {IS_EU || IS_NA ? (
                <ul className="box-eu">
                    {list_eu_na?.map((item, k) => (
                        <li className={`item item-${k + 1}`} key={k} style={{ gridArea: `box-${k + 1}` }}>
                            <div className="item-img">
                                <img src={item.pc} alt={item.title} width={'100%'} height={'100%'} />
                            </div>
                            <div className="item-title">{item.title}</div>
                        </li>
                    ))}
                </ul>
            ) : (
                <EfWhatInBox list={locale === 'ph' ? list_PH : list} />
            )}
            {IS_EU_SITES && pageStatus === 'statusB' && <EfSpec className="spec-x" />}
        </div>
    );
}
